/**
 * Hyperliquid API Configuration
 * Constants for API URLs, timeouts, and limits
 */

export const HYPERLIQUID_CONFIG = {
  API_URL: 'https://api.hyperliquid.xyz/info',
  WS_URL: 'wss://api.hyperliquid.xyz/ws',
  MAX_RECONNECT_ATTEMPTS: 5,
  RECONNECT_DELAY_BASE: 1000, // 1 second
  HEARTBEAT_INTERVAL: 30000, // 30 seconds
  MAX_MONITORED_WALLETS: 10, // From API docs: https://hyperliquid.gitbook.io/hyperliquid-docs/for-developers/api/rate-limits-and-user-limits
} as const;
